import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=0dd332d2&scoped=true&"
import script from "./ProjectList.vue?vue&type=script&lang=js&"
export * from "./ProjectList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectList.vue?vue&type=style&index=0&id=0dd332d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd332d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dd332d2')) {
      api.createRecord('0dd332d2', component.options)
    } else {
      api.reload('0dd332d2', component.options)
    }
    module.hot.accept("./ProjectList.vue?vue&type=template&id=0dd332d2&scoped=true&", function () {
      api.rerender('0dd332d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/ProjectList.vue"
export default component.exports